import { registerPlugin } from '@capacitor/core';

export interface SeasonalSplashPlugin {
  show(): Promise<void>;

  hide(): Promise<void>;
}

const SeasonalSplash = registerPlugin<SeasonalSplashPlugin>('SeasonalSplashPlugin', {
  web: () => {
    return {
      show: async () => {},
      hide: async () => {},
    };
  },
});

export default SeasonalSplash;
